module.exports = __webpack_public_path__ + "static/media/day_two.f8022046.jpg";